import React from 'react';
import { Radio as MuiRadio, RadioProps as MuiRadioProps } from '@mui/material';
import { RadioSize, RadioVariant } from '../../../config/radio';

export interface RadioProps extends Omit<MuiRadioProps, 'size' | 'color'> {
  variant?: RadioVariant;
  size?: RadioSize;
}

export const Radio: React.FC<RadioProps> = ({
  variant = RadioVariant.PRIMARY,
  size = RadioSize.MEDIUM,
  ...props
}) => {
  // Map our custom variant to MUI color prop
  const getMuiColor = (
    variant: RadioVariant,
  ): 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' => {
    switch (variant) {
      case RadioVariant.PRIMARY:
        return 'primary';
      case RadioVariant.SECONDARY:
        return 'secondary';
      case RadioVariant.SUCCESS:
        return 'success';
      case RadioVariant.ERROR:
        return 'error';
      case RadioVariant.WARNING:
        return 'warning';
      case RadioVariant.INFO:
        return 'info';
      default:
        return 'primary';
    }
  };

  // Map our size enum to MUI's supported sizes
  const getMuiSize = (size: RadioSize): 'small' | 'medium' => {
    switch (size) {
      case RadioSize.SMALL:
        return 'small';
      case RadioSize.MEDIUM:
        return 'medium';
      default:
        return 'medium';
    }
  };

  return (
    <MuiRadio color={getMuiColor(variant)} size={getMuiSize(size)} {...props} />
  );
};

export default Radio;
